export default __webpack_public_path__ + "static/media/sanitizer5.522a15a6.jpg";